import storage from 'redux-persist/lib/storage';

import { createApiReducer, chainReducers, INITIAL_API_STATUS } from 'src/services/api';

import { User } from 'src/services/users';
import { AuthState } from './types';
import { AuthActionTypes } from './actions';
import { transformAuthUser } from '../transformations';

const initialCurrentUserState: User = {
  email: '',
  name: '',
  id: '',
  app_roles: [],
  status: '',
  preferredUsername: '',
};

const initialState: AuthState = {
  token: null,
  userInfo: initialCurrentUserState,
  _status: INITIAL_API_STATUS,
  logoutInitiated: false,
};

const logoutState: AuthState = {
  ...initialState,
  logoutInitiated: true,
};

const authLocalReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case AuthActionTypes.UPDATE_AUTH_USER:
      return {
        ...state,
        userInfo: action.payload,
      };
    default:
      return state;
  }
};

const auth = createApiReducer(
  [AuthActionTypes.SIGN_IN_START, AuthActionTypes.SIGN_IN_SUCCESS, AuthActionTypes.SIGN_IN_FAILURE],
  (data) => transformAuthUser(data),
  (data) => data.error.message,
);

const signOut = (state: AuthState = initialState, action: any) => {
  switch (action.type) {
    case AuthActionTypes.SIGN_OUT:
      window.console.log('Removing redux persistent data.');
      storage.removeItem('persist:root');
      return logoutState;
    default:
      return state;
  }
};

export default chainReducers(initialState, auth, signOut, authLocalReducer);
